import { Link, Text } from '@chakra-ui/react';
import type { Dispatch, SetStateAction } from 'react';
import InfoBanner from '../../common/InfoBanner';
import { CustomInfoIcon } from '../../../theme/icons/CustomInfoIcon';
import { useEnhancedDesignForTemplate } from './hooks/useEnhancedDesignForTemplate';
import {
  BUILDER_DEVICE_TAB,
  BUILDER_PASS_TAB,
  type BuilderDeviceTab,
  type BuilderPassTab,
} from './utils/templateBuilderTabs';
import { ENHANCED_GENERIC_SECTION_ID } from './utils/appleEnhancedDesignConstants';
import { MAIN_TABS, navigateToSection } from './utils/sectionNavigation';

interface EnhancedDesignTryBannerProps {
  isLoading: boolean;
  setSelectedTab: Dispatch<SetStateAction<BuilderDeviceTab>>;
  setSelectedPassTab: Dispatch<SetStateAction<BuilderPassTab>>;
  setSelectedMainTabIndex: (index: number) => void;
}

const EnhancedDesignTryBanner = ({
  isLoading,
  setSelectedTab,
  setSelectedPassTab,
  setSelectedMainTabIndex,
}: EnhancedDesignTryBannerProps) => {
  const { available, allowedDesigns, storedDesign } =
    useEnhancedDesignForTemplate();

  if (
    isLoading ||
    !available ||
    !allowedDesigns.includes('generic') ||
    storedDesign !== null
  ) {
    return null;
  }

  const handleTryIt = () =>
    navigateToSection(
      { setSelectedMainTabIndex, setSelectedTab, setSelectedPassTab },
      {
        mainTabIndex: MAIN_TABS.PASS_TEMPLATE,
        tab: BUILDER_DEVICE_TAB.APPLE,
        passTab: BUILDER_PASS_TAB.FRONT,
        sectionId: ENHANCED_GENERIC_SECTION_ID,
      }
    );

  return (
    <InfoBanner
      color="#009BD6"
      bg="rgba(0, 155, 214, 0.2)"
      icon={<CustomInfoIcon boxSize="22px" color="#009BD6" flexShrink={0} />}
      py={2}
      mt={0}
    >
      <Text
        fontSize="14px"
        lineHeight="1.5"
        color="black"
        fontWeight="semibold"
      >
        iOS 27 enhanced passes are here.
      </Text>
      <Text fontSize="14px" lineHeight="1.5" color="black">
        Create an enhanced version of any generic pass with full-bleed artwork
        and featured actions.{' '}
        <Link
          as="button"
          type="button"
          textDecoration="underline"
          lineHeight="1.5"
          verticalAlign="baseline"
          onClick={handleTryIt}
        >
          Try it now →
        </Link>
      </Text>
    </InfoBanner>
  );
};

export default EnhancedDesignTryBanner;
